import React, { Component } from "react";

export default class NotFound extends Component {
  render() {
    return (
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-animation">
            <div className="animation-circle circle-1"></div>
            <div className="animation-circle circle-2"></div>
            <div className="animation-circle circle-3"></div>
            <div className="error-code">404</div>
          </div>

          <h1 className="not-found-title">¡Ups! Página no encontrada</h1>

          <p className="not-found-description">
            Lo sentimos, la página que estás buscando no existe o ha sido
            movida. Puede que hayas escrito mal la URL o que la página haya sido
            eliminada.
          </p>

          <div className="not-found-actions">
            <button
              className="btn btn-primary"
              onClick={() => window.history.back()}
            >
              <i className="fas fa-arrow-left"></i> Volver atrás
            </button>

            <button
              className="btn btn-gradient"
              onClick={() => (window.location.href = "/inicio")}
            >
              <i className="fas fa-home"></i> Ir al inicio
            </button>
          </div>

          <div className="not-found-stats">
            <div className="stat-item">
              <div className="stat-number">500K+</div>
              <div className="stat-label">Usuarios activos</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Streams en vivo</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Países</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
